<template>
  <ReportBaseSelectFilter
    class="item-type-filter"
    :options="options"
    query-property="item_type"
    :multiple="false"
    :allow-clear="false"
    label="Item type"
  />
</template>

<script>
export default {
  name: 'ReportItemTypeFilter',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>
